import { Flex, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import ButtonLink from '../../generic/button/ButtonLink';

const ButtonAddSameSession = ({ productTitle, ...props }) => {
  return (
    <Flex w="full" mt={4}>
      <ButtonLink {...props} m="0 auto">
        <Trans>Add:</Trans>
        <Text fontWeight="bold" ml="2px">
          {productTitle}
        </Text>
      </ButtonLink>
    </Flex>
  );
};

export default ButtonAddSameSession;
